/**
 * Derives whether the "Ends at 23:59:59" checkbox should be available for a
 * CALENDAR_FIXED frequency configuration.
 *
 * REBUILD-263 client decision: the checkbox is shown whenever Starts At + Overdue hits or
 * crosses midnight of the start day, regardless of the recurrence cadence. Legacy's
 * "cadence longer than 24h" gate is intentionally not applied.
 *
 * TIMED tasks are excluded at the modal level (CALENDAR_FIXED precondition).
 *
 * `overdueMinutes` corresponds to lateTimeIntervalHours stored in minutes
 * (see InstrumentTaskIntervalType Ruby model).
 */
const MINUTES_PER_DAY = 24 * 60

export function endsAtMidnightEligible({
  startsAt,
  overdueMinutes,
}: {
  startsAt: string
  overdueMinutes: number
}): boolean {
  const [hourStr, minuteStr] = startsAt.split(':')
  const startMinutes = Number(hourStr ?? 0) * 60 + Number(minuteStr ?? 0)
  return startMinutes + overdueMinutes >= MINUTES_PER_DAY
}
